import React from "react";
import Layout from "./Layout";
import {Button, Typography} from "@mui/material";
import {GitHub, LinkedIn, Twitter} from "@mui/icons-material";
import simar from '../assets/simar-hello.png';

const Contact = () => {
    const Connect = () => {
        return (
            <div style={{margin: '10% 0', color: '#ffffff'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-sm-6" style={{marginTop: '2%', color: '#ffffff'}}>
                            <Typography variant='h5' component='h5'>Let's Talk!</Typography>
                            <div style={{marginTop: '1%'}}>
                                <ul>
                                    <li>E-Mail: professional.simardeepsingh@gmail.com</li>
                                </ul>
                            </div>
                            <div style={{marginTop: '1%'}}>
                                <Typography variant='h6' component='h6'>Social Media</Typography>
                                <div style={{display: 'flex', marginTop: '2%'}}>
                                    <div style={{marginRight: '2%'}}>
                                        <a href="https://www.linkedin.com/in/simardeepsingh99/" rel="noreferrer"
                                           target="_blank" style={{textDecoration: 'none'}}>
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                style={{width: '200px', color: '#16a0ec', borderColor: '#16a0ec'}}
                                                startIcon={<LinkedIn/>}>
                                                LinkedIn
                                            </Button>
                                        </a>
                                    </div>
                                    <div style={{marginRight: '2%'}}>
                                        <a href="https://twitter.com/simardeep99" rel="noreferrer" target="_blank"
                                           style={{textDecoration: 'none'}}>
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                style={{width: '200px', color: '#52a0ff', borderColor: '#52a0ff'}}
                                                startIcon={<Twitter/>}>
                                                Twitter
                                            </Button>
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://github.com/tombstoneghost" rel="noreferrer" target="_blank"
                                           style={{textDecoration: 'none'}}>
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                style={{width: '200px', color: '#ffffff', borderColor: '#ffffff'}}
                                                startIcon={<GitHub/>}>
                                                Github
                                            </Button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div style={{marginTop: '2%'}}>
                                <Typography variant='h6' component='h6'>Hacking Platforms</Typography>
                                <div style={{display: 'flex', marginTop: '2%'}}>
                                    <div style={{marginRight: '2%'}}>
                                        <a href='https://app.hackthebox.eu/profile/276640' style={{textDecoration: 'none'}}
                                           target='_blank' rel='noreferrer'>
                                            <img src="https://www.hackthebox.eu/badge/image/276640" alt='HackTheBox'/>
                                        </a>
                                    </div>
                                    <div>
                                        <script src="https://tryhackme.com/badge/320902"></script>
                                        <a href='https://tryhackme.com/p/tombstoneGhost' style={{textDecoration: 'none'}}
                                           target='_blank' rel='noreferrer'>
                                            <img src="https://tryhackme-badges.s3.amazonaws.com/tombstoneGhost.png"
                                                 alt="TryHackMe" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div style={{marginTop: '2%'}}>
                                <Typography variant='h6' component='h6'>Liked my Work?</Typography>
                                <div style={{marginTop: '1%'}}>
                                    <a href="https://www.buymeacoffee.com/tombstoneghost" target="_blank" rel='noreferrer'>
                                        <img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                                             alt="Buy Me A Coffee" style={{height: '60px', width: '217px'}}/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="text-right">
                                <img src={simar} alt="Hello" height="90%" width="75%"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    return (
        <Layout>
            <Connect />
        </Layout>
    )
};

export default Contact;